"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundProposalDepositArgs = exports.RevokeGoverningTokensArgs = exports.SetGovernanceDelegateArgs = exports.CreateNativeTreasuryArgs = exports.UpdateProgramMetadataArgs = exports.CreateTokenOwnerRecordArgs = exports.SetRealmConfigArgs = exports.SetRealmAuthorityArgs = exports.SetRealmAuthorityAction = exports.FlagTransactionErrorArgs = exports.ExecuteTransactionArgs = exports.RemoveTransactionArgs = exports.InsertTransactionArgs = exports.FinalizeVoteArgs = exports.RelinquishVoteArgs = exports.CastVoteArgs = exports.Vote = exports.VoteKind = exports.VoteChoice = exports.YesNoVote = exports.CancelProposalArgs = exports.SignOffProposalArgs = exports.AddSignatoryArgs = exports.CreateProposalArgs = exports.SetGovernanceConfigArgs = exports.CreateTokenGovernanceArgs = exports.CreateMintGovernanceArgs = exports.CreateProgramGovernanceArgs = exports.CreateGovernanceArgs = exports.WithdrawGoverningTokensArgs = exports.DepositGoverningTokensArgs = exports.CreateRealmArgs = exports.GovernanceInstruction = void 0;
var GovernanceInstruction;
(function (GovernanceInstruction) {
    GovernanceInstruction[GovernanceInstruction["CreateRealm"] = 0] = "CreateRealm";
    GovernanceInstruction[GovernanceInstruction["DepositGoverningTokens"] = 1] = "DepositGoverningTokens";
    GovernanceInstruction[GovernanceInstruction["WithdrawGoverningTokens"] = 2] = "WithdrawGoverningTokens";
    GovernanceInstruction[GovernanceInstruction["SetGovernanceDelegate"] = 3] = "SetGovernanceDelegate";
    GovernanceInstruction[GovernanceInstruction["CreateGovernance"] = 4] = "CreateGovernance";
    GovernanceInstruction[GovernanceInstruction["CreateProgramGovernance"] = 5] = "CreateProgramGovernance";
    GovernanceInstruction[GovernanceInstruction["CreateProposal"] = 6] = "CreateProposal";
    GovernanceInstruction[GovernanceInstruction["AddSignatory"] = 7] = "AddSignatory";
    GovernanceInstruction[GovernanceInstruction["RemoveSignatory"] = 8] = "RemoveSignatory";
    GovernanceInstruction[GovernanceInstruction["InsertTransaction"] = 9] = "InsertTransaction";
    GovernanceInstruction[GovernanceInstruction["RemoveTransaction"] = 10] = "RemoveTransaction";
    GovernanceInstruction[GovernanceInstruction["CancelProposal"] = 11] = "CancelProposal";
    GovernanceInstruction[GovernanceInstruction["SignOffProposal"] = 12] = "SignOffProposal";
    GovernanceInstruction[GovernanceInstruction["CastVote"] = 13] = "CastVote";
    GovernanceInstruction[GovernanceInstruction["FinalizeVote"] = 14] = "FinalizeVote";
    GovernanceInstruction[GovernanceInstruction["RelinquishVote"] = 15] = "RelinquishVote";
    GovernanceInstruction[GovernanceInstruction["ExecuteTransaction"] = 16] = "ExecuteTransaction";
    GovernanceInstruction[GovernanceInstruction["CreateMintGovernance"] = 17] = "CreateMintGovernance";
    GovernanceInstruction[GovernanceInstruction["CreateTokenGovernance"] = 18] = "CreateTokenGovernance";
    GovernanceInstruction[GovernanceInstruction["SetGovernanceConfig"] = 19] = "SetGovernanceConfig";
    GovernanceInstruction[GovernanceInstruction["FlagTransactionError"] = 20] = "FlagTransactionError";
    GovernanceInstruction[GovernanceInstruction["SetRealmAuthority"] = 21] = "SetRealmAuthority";
    GovernanceInstruction[GovernanceInstruction["SetRealmConfig"] = 22] = "SetRealmConfig";
    GovernanceInstruction[GovernanceInstruction["CreateTokenOwnerRecord"] = 23] = "CreateTokenOwnerRecord";
    GovernanceInstruction[GovernanceInstruction["UpdateProgramMetadata"] = 24] = "UpdateProgramMetadata";
    GovernanceInstruction[GovernanceInstruction["CreateNativeTreasury"] = 25] = "CreateNativeTreasury";
    GovernanceInstruction[GovernanceInstruction["RevokeGoverningTokens"] = 26] = "RevokeGoverningTokens";
    GovernanceInstruction[GovernanceInstruction["RefundProposalDeposit"] = 27] = "RefundProposalDeposit";
})(GovernanceInstruction = exports.GovernanceInstruction || (exports.GovernanceInstruction = {}));
var CreateRealmArgs = /** @class */ (function () {
    function CreateRealmArgs(args) {
        this.instruction = GovernanceInstruction.CreateRealm;
        this.name = args.name;
        this.configArgs = args.configArgs;
    }
    return CreateRealmArgs;
}());
exports.CreateRealmArgs = CreateRealmArgs;
var DepositGoverningTokensArgs = /** @class */ (function () {
    function DepositGoverningTokensArgs(args) {
        this.instruction = GovernanceInstruction.DepositGoverningTokens;
        this.amount = args.amount;
    }
    return DepositGoverningTokensArgs;
}());
exports.DepositGoverningTokensArgs = DepositGoverningTokensArgs;
var WithdrawGoverningTokensArgs = /** @class */ (function () {
    function WithdrawGoverningTokensArgs() {
        this.instruction = GovernanceInstruction.WithdrawGoverningTokens;
    }
    return WithdrawGoverningTokensArgs;
}());
exports.WithdrawGoverningTokensArgs = WithdrawGoverningTokensArgs;
var CreateGovernanceArgs = /** @class */ (function () {
    function CreateGovernanceArgs(args) {
        this.instruction = GovernanceInstruction.CreateGovernance;
        this.config = args.config;
    }
    return CreateGovernanceArgs;
}());
exports.CreateGovernanceArgs = CreateGovernanceArgs;
var CreateProgramGovernanceArgs = /** @class */ (function () {
    function CreateProgramGovernanceArgs(args) {
        this.instruction = GovernanceInstruction.CreateProgramGovernance;
        this.config = args.config;
        this.transferUpgradeAuthority = !!args.transferUpgradeAuthority;
    }
    return CreateProgramGovernanceArgs;
}());
exports.CreateProgramGovernanceArgs = CreateProgramGovernanceArgs;
var CreateMintGovernanceArgs = /** @class */ (function () {
    function CreateMintGovernanceArgs(args) {
        this.instruction = GovernanceInstruction.CreateMintGovernance;
        this.config = args.config;
        this.transferMintAuthorities = !!args.transferMintAuthorities;
    }
    return CreateMintGovernanceArgs;
}());
exports.CreateMintGovernanceArgs = CreateMintGovernanceArgs;
var CreateTokenGovernanceArgs = /** @class */ (function () {
    function CreateTokenGovernanceArgs(args) {
        this.instruction = GovernanceInstruction.CreateTokenGovernance;
        this.config = args.config;
        this.transferTokenOwner = !!args.transferTokenOwner;
    }
    return CreateTokenGovernanceArgs;
}());
exports.CreateTokenGovernanceArgs = CreateTokenGovernanceArgs;
var SetGovernanceConfigArgs = /** @class */ (function () {
    function SetGovernanceConfigArgs(args) {
        this.instruction = GovernanceInstruction.SetGovernanceConfig;
        this.config = args.config;
    }
    return SetGovernanceConfigArgs;
}());
exports.SetGovernanceConfigArgs = SetGovernanceConfigArgs;
var CreateProposalArgs = /** @class */ (function () {
    function CreateProposalArgs(args) {
        this.instruction = GovernanceInstruction.CreateProposal;
        this.name = args.name;
        this.descriptionLink = args.descriptionLink;
        this.governingTokenMint = args.governingTokenMint;
        this.voteType = args.voteType;
        this.options = args.options;
        this.useDenyOption = args.useDenyOption;
        this.proposalSeed = args.proposalSeed;
    }
    return CreateProposalArgs;
}());
exports.CreateProposalArgs = CreateProposalArgs;
var AddSignatoryArgs = /** @class */ (function () {
    function AddSignatoryArgs(args) {
        this.instruction = GovernanceInstruction.AddSignatory;
        this.signatory = args.signatory;
    }
    return AddSignatoryArgs;
}());
exports.AddSignatoryArgs = AddSignatoryArgs;
var SignOffProposalArgs = /** @class */ (function () {
    function SignOffProposalArgs() {
        this.instruction = GovernanceInstruction.SignOffProposal;
    }
    return SignOffProposalArgs;
}());
exports.SignOffProposalArgs = SignOffProposalArgs;
var CancelProposalArgs = /** @class */ (function () {
    function CancelProposalArgs() {
        this.instruction = GovernanceInstruction.CancelProposal;
    }
    return CancelProposalArgs;
}());
exports.CancelProposalArgs = CancelProposalArgs;
var YesNoVote;
(function (YesNoVote) {
    YesNoVote[YesNoVote["Yes"] = 0] = "Yes";
    YesNoVote[YesNoVote["No"] = 1] = "No";
})(YesNoVote = exports.YesNoVote || (exports.YesNoVote = {}));
var VoteChoice = /** @class */ (function () {
    function VoteChoice(args) {
        this.rank = args.rank;
        this.weightPercentage = args.weightPercentage;
    }
    return VoteChoice;
}());
exports.VoteChoice = VoteChoice;
var VoteKind;
(function (VoteKind) {
    VoteKind[VoteKind["Approve"] = 0] = "Approve";
    VoteKind[VoteKind["Deny"] = 1] = "Deny";
    VoteKind[VoteKind["Abstain"] = 2] = "Abstain";
    VoteKind[VoteKind["Veto"] = 3] = "Veto";
})(VoteKind = exports.VoteKind || (exports.VoteKind = {}));
var Vote = /** @class */ (function () {
    function Vote(args) {
        this.voteType = args.voteType;
        this.approveChoices = args.approveChoices;
        this.deny = args.deny;
        this.veto = args.veto;
    }
    Vote.prototype.toYesNoVote = function () {
        switch (this.voteType) {
            case VoteKind.Deny: {
                return YesNoVote.No;
            }
            case VoteKind.Approve: {
                return YesNoVote.Yes;
            }
        }
    };
    Vote.fromYesNoVote = function (yesNoVote) {
        switch (yesNoVote) {
            case YesNoVote.Yes: {
                return new Vote({
                    voteType: VoteKind.Approve,
                    approveChoices: [new VoteChoice({ rank: 0, weightPercentage: 100 })],
                    deny: undefined,
                    veto: undefined,
                });
            }
            case YesNoVote.No: {
                return new Vote({
                    voteType: VoteKind.Deny,
                    approveChoices: undefined,
                    deny: true,
                    veto: undefined,
                });
            }
        }
    };
    return Vote;
}());
exports.Vote = Vote;
var CastVoteArgs = /** @class */ (function () {
    function CastVoteArgs(args) {
        this.instruction = GovernanceInstruction.CastVote;
        this.yesNoVote = args.yesNoVote;
        this.vote = args.vote;
    }
    return CastVoteArgs;
}());
exports.CastVoteArgs = CastVoteArgs;
var RelinquishVoteArgs = /** @class */ (function () {
    function RelinquishVoteArgs() {
        this.instruction = GovernanceInstruction.RelinquishVote;
    }
    return RelinquishVoteArgs;
}());
exports.RelinquishVoteArgs = RelinquishVoteArgs;
var FinalizeVoteArgs = /** @class */ (function () {
    function FinalizeVoteArgs() {
        this.instruction = GovernanceInstruction.FinalizeVote;
    }
    return FinalizeVoteArgs;
}());
exports.FinalizeVoteArgs = FinalizeVoteArgs;
var InsertTransactionArgs = /** @class */ (function () {
    function InsertTransactionArgs(args) {
        this.instruction = GovernanceInstruction.InsertTransaction;
        this.index = args.index;
        this.optionIndex = args.optionIndex;
        this.holdUpTime = args.holdUpTime;
        // V1
        this.instructionData = args.instructionData;
        // V2
        this.instructions = args.instructions;
    }
    return InsertTransactionArgs;
}());
exports.InsertTransactionArgs = InsertTransactionArgs;
var RemoveTransactionArgs = /** @class */ (function () {
    function RemoveTransactionArgs() {
        this.instruction = GovernanceInstruction.RemoveTransaction;
    }
    return RemoveTransactionArgs;
}());
exports.RemoveTransactionArgs = RemoveTransactionArgs;
var ExecuteTransactionArgs = /** @class */ (function () {
    function ExecuteTransactionArgs() {
        this.instruction = GovernanceInstruction.ExecuteTransaction;
    }
    return ExecuteTransactionArgs;
}());
exports.ExecuteTransactionArgs = ExecuteTransactionArgs;
var FlagTransactionErrorArgs = /** @class */ (function () {
    function FlagTransactionErrorArgs() {
        this.instruction = GovernanceInstruction.FlagTransactionError;
    }
    return FlagTransactionErrorArgs;
}());
exports.FlagTransactionErrorArgs = FlagTransactionErrorArgs;
var SetRealmAuthorityAction;
(function (SetRealmAuthorityAction) {
    SetRealmAuthorityAction[SetRealmAuthorityAction["SetUnchecked"] = 0] = "SetUnchecked";
    SetRealmAuthorityAction[SetRealmAuthorityAction["SetChecked"] = 1] = "SetChecked";
    SetRealmAuthorityAction[SetRealmAuthorityAction["Remove"] = 2] = "Remove";
})(SetRealmAuthorityAction = exports.SetRealmAuthorityAction || (exports.SetRealmAuthorityAction = {}));
var SetRealmAuthorityArgs = /** @class */ (function () {
    function SetRealmAuthorityArgs(args) {
        this.instruction = GovernanceInstruction.SetRealmAuthority;
        // V1
        this.newRealmAuthority = args.newRealmAuthority;
        // V2
        this.action = args.action;
    }
    return SetRealmAuthorityArgs;
}());
exports.SetRealmAuthorityArgs = SetRealmAuthorityArgs;
var SetRealmConfigArgs = /** @class */ (function () {
    function SetRealmConfigArgs(args) {
        this.instruction = GovernanceInstruction.SetRealmConfig;
        this.configArgs = args.configArgs;
    }
    return SetRealmConfigArgs;
}());
exports.SetRealmConfigArgs = SetRealmConfigArgs;
var CreateTokenOwnerRecordArgs = /** @class */ (function () {
    function CreateTokenOwnerRecordArgs() {
        this.instruction = GovernanceInstruction.CreateTokenOwnerRecord;
    }
    return CreateTokenOwnerRecordArgs;
}());
exports.CreateTokenOwnerRecordArgs = CreateTokenOwnerRecordArgs;
var UpdateProgramMetadataArgs = /** @class */ (function () {
    function UpdateProgramMetadataArgs() {
        this.instruction = GovernanceInstruction.UpdateProgramMetadata;
    }
    return UpdateProgramMetadataArgs;
}());
exports.UpdateProgramMetadataArgs = UpdateProgramMetadataArgs;
var CreateNativeTreasuryArgs = /** @class */ (function () {
    function CreateNativeTreasuryArgs() {
        this.instruction = GovernanceInstruction.CreateNativeTreasury;
    }
    return CreateNativeTreasuryArgs;
}());
exports.CreateNativeTreasuryArgs = CreateNativeTreasuryArgs;
var SetGovernanceDelegateArgs = /** @class */ (function () {
    function SetGovernanceDelegateArgs(args) {
        this.instruction = GovernanceInstruction.SetGovernanceDelegate;
        this.newGovernanceDelegate = args.newGovernanceDelegate;
    }
    return SetGovernanceDelegateArgs;
}());
exports.SetGovernanceDelegateArgs = SetGovernanceDelegateArgs;
var RevokeGoverningTokensArgs = /** @class */ (function () {
    function RevokeGoverningTokensArgs(args) {
        this.instruction = GovernanceInstruction.RevokeGoverningTokens;
        this.amount = args.amount;
    }
    return RevokeGoverningTokensArgs;
}());
exports.RevokeGoverningTokensArgs = RevokeGoverningTokensArgs;
var RefundProposalDepositArgs = /** @class */ (function () {
    function RefundProposalDepositArgs() {
        this.instruction = GovernanceInstruction.RefundProposalDeposit;
    }
    return RefundProposalDepositArgs;
}());
exports.RefundProposalDepositArgs = RefundProposalDepositArgs;
//# sourceMappingURL=instructions.js.map